module.exports = __webpack_public_path__ + "static/media/zen_paper_sidebyside.16b33629.png";